import { internalErrorBusinessComp } from '../../../../../Components/InternalError/InternalError';
import NodeQuery, {
  INodeData,
} from '../../../../../Components/QueryComponents/NodeQuery/NodeQuery';
import { getStringValue } from '../../../../../Utils/dataUtils';
import {
  IObjektVy,
  BusinessCollectionCompType,
} from '../../../../../Types/ObjektVy';
import {
  IClientBusinessModel,
  IClientAttributeModel,
} from '../../../../../Types/ClientModelTypes';
import { keys } from 'ramda';
import {
  AttributeValueSizeType,
  AttributeValueSizeTypeWithAuto,
} from '../../../../../Components/Attributes/AttributeValue/AttributeValue';
import { getAttributeValueAutoSize } from '../../../../../Components/Attributes/Utils/AttributeValueAutoSizeUtils';
import { headerColumns } from '../../Utils/defaultColumns';
import EditableAttribute from '../../../../../Components/Attributes/EditableAttribute/EditableAttribute';

import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import { TSelectedDetail } from '../../../../../Types/MasterDetailTypes';

interface IConfig {
  collectionName: string;
  fieldDefs: string[];
  caption?: string;
  // Optional mapper that transforms NodeQuery result + incoming props into final component props
  mapProps?: (params: {
    data: INodeData | null;
    id: TSelectedDetail;
    collectionName: string;
  }) => Record<string, any>;
}

const connectNode =
  (config: IConfig) =>
  (WrappedComponent: React.ComponentType<any>) =>
  (props: { id: TSelectedDetail }) =>
    (
      <NodeQuery
        collectionName={config.collectionName}
        id={selectedId(props.id)}
        fieldDefs={config.fieldDefs}
        caption={config.caption}
      >
        {(loading, data) => {
          const mapped = config.mapProps
            ? config.mapProps({
                data,
                id: props.id,
                collectionName: config.collectionName,
              })
            : { data, collectionName: config.collectionName, ...props };
          return <WrappedComponent {...mapped} />;
        }}
      </NodeQuery>
    );
const ConnectedAttributeValue = (
  businessModel: IClientBusinessModel,
  attribute: IClientAttributeModel,
  size: AttributeValueSizeType = 'medium',
  header: boolean,
  caption?: string
): BusinessCollectionCompType => {
  const attributeName = attribute.AttributeName;
  return connectNode({
    collectionName: businessModel.CollectionName,
    fieldDefs: [attributeName],
    caption: caption,
    mapProps: ({ data }) => ({
      collection: businessModel,
      attribute,
      value: getStringValue(data, [attributeName]),
      label: attribute.DisplayLabel,
      editMode: false, // Konstant läsläge tills en formContext utarbetats.
      disabled: !attribute.GUIEditable,
      onChange: () => {},
      size,
      header,
    }),
  })(EditableAttribute);
};

// vy för ett attribut
const faltVy = (
  attributeName: string,
  sizeParam?: AttributeValueSizeTypeWithAuto
): IObjektVy => ({
  type: 'ObjektVy',
  id: attributeName,
  info: { komponentMedRubrik: true },
  def: (businessModel: IClientBusinessModel) => {
    const attr = businessModel.Attributes[attributeName];
    const size =
      sizeParam == null
        ? 'medium'
        : sizeParam === 'auto'
        ? getAttributeValueAutoSize(attr)
        : sizeParam;
    if (attr) {
      const isHeader = Boolean(
        headerColumns(businessModel.CollectionName).find(
          x => x.attributeDef === attributeName
        )
      );
      const comp = ConnectedAttributeValue(
        businessModel,
        attr,
        size,
        isHeader,
        attributeName
      );
      return {
        caption: '',
        comp: comp,
      };
    }
    return {
      caption: 'attribut saknas',
      comp: internalErrorBusinessComp(
        'ab8eba7a-4e48-4f8b-a5d7-14e17c4390a4',
        `Attributet ${attributeName} saknas i ${businessModel.CollectionName}.
        Möjliga värden är: ${keys(businessModel.Attributes)}`
      ),
    };
  },
});

/** @component */
export default faltVy;
